import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import HorizontalBar from "./HorizontalBar";
import "./styles/dashboardLayout.css";

export default function DashboardLayout() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className={`dashboard-container ${menuOpen ? "menu-open" : ""}`}>
      <Navbar menuOpen={menuOpen} closeMenu={closeMenu} />
      <main className="main-content">
        <HorizontalBar toggleMenu={toggleMenu} />
        <div className="content-area">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
